import React, { useState, useEffect, useCallback } from "react";
import  {styled, Box, Button, Input, Stack } from "@mui/material";
import {theme} from "@material-ui/core";
import Select from "react-select";

const TXTRoundedDiv=styled("div")(({theme})=> ({
  borderRadius: theme.shape.borderRadius,
  border: "1px solid #6BD5C0",
  width: "100%",
  fontSize: "14px",
  marginBottom: "10px"
}));

const StyledBox = styled(Box)({
  marginBottom: "2px",
  marginLeft: "2px",
  marginRight: "2px"
});

const StyledInput = styled(Input)({
  fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"
});

const StyledSelect = styled(Select)({
    fontSize: "14px",
    width: "98%",
    height: "98%"
  });

export default function FRMNewProjectTest (props){
    
    const [ProjectCategory, setProjectCategory]=useState({});
    const [ProjectName, setProjectName]=useState('');
    const [Country, setCountry]=useState('');
    const [City, setCity]=useState('');
    const [District, setDistrict]=useState('');
    const [Ward, setWard]=useState('');
    const [ResponseStatus, setResponseStatus]=useState('');
    const [ProjectCategorySelected, setProjectCategorySelected]=useState({});
    
    /***
    const [ProjectCategory, setProjectCategoryList]=useState([
        {id: 0, value: 'Select Project Category', label: 'Select Project Category'}
    ]);
     ***/
    
    const [timeToValidate, setTimeToValidate]=useState(false);
    const [foundError, setFoundError]=useState(false);
    const [errors, setErrors]=useState(false);
    /***
   
    ***/

    const [formErrors , setFormErrors]=useState({});
    const [formData, setFormData] = useState({
      project_category_id: '',
      project_name: '',
      country: '',
      city: '',
      district: '',
      ward: '',
      project_code: 'ABC123',
      project_status: 'Active'
    });
    
    
    useEffect(()=>{
      console.log("formData.project_category_id=" + formData.project_category_id);
    }, [formData.project_category_id])
    

    const onHandleChange = useCallback((value, name) => {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      console.log("Things ::: name=" + name + ", value=" + value);
      console.log("Things ::: name=" + name + ", value=" + value);
    }, []);
    
    const handleChangeSelect = (e) => {
      const { name, value } = e;
      if(name==="project_category_id"){
        console.log("project_category_id selected");
      }
      else{
        console.log("XXX=" + e.value);
      }
      
      setFormData({
          ...formData,
          [name]: e.id,
      });
      console.log("222 final e.id =" + e.id);
      console.log("XXX final project_category_id=" + formData['project_category_id']);
      console.log("ZZZ final project_category_id=" + formData.project_category_id);
      setErrors({});
    };

    const handleChangeInput = (e) => {
      
      const { name, value } = e.target;
      
      console.log("XYZ=" + e.target.value);
      console.log("XYZZ=" + value);
      console.log("XYZZ name=" + name);


      setFormData({
          ...formData,
          [name]: value,
      });
      
      console.log("XYZZ formData.district=" + formData.district);

      setErrors({});
    };
    
    /***/
    const validateForm = (data) => {
      const errors = {};
      
      console.log("final data.city =" + data.city);
      console.log("final data.district =" + data.district);
      console.log("final data.ward =" + data.ward);
      
      console.log("data.project_category_id=" + data.project_category_id);
      console.log("data.project_category_id.trim()=" + (data.project_category_id.toString()).trim());
      
      if (!((data.project_category_id).toString()).trim()) {
        errors.project_category_id = 'Project Category is required';
      }
      
      if (!data.project_name.trim()) {
        errors.project_name = 'Project Name is required';
      }
      
      if (!data.country.trim()) {
        errors.country = 'Country is required';
      }

      if (!data.city.trim()) {
        errors.city = 'City is required';
      }
      
      if (!data.district.trim()) {
        errors.district = 'District is required';
      }
      
      console.log("data.ward=" + data.ward);
      if (!data.ward.trim()) {
        errors.ward = 'Ward is required';
        console.log("71");
      }

      console.log("xcxc");
      /***
      if (!data.email.trim()) {
        errors.email = 'Email is required';
      } else if (!/\S+@\S+\.\S+/.test(data.email)) {
                  /\S+@\S+\.\S+/
        errors.email = 'Email is invalid';
      }
      ***/
      /*
      if (!data.password) {
        errors.password = 'Password is required';
      } else if (data.password.length < 8) {
        errors.password = `Password must be at 
        least 8 characters long`;
      }
  
      if (data.confirmPassword !== data.password) {
        errors.confirmPassword = 'Passwords do not match';
      }
      */
      return errors;
    };
  
    /***/

    const handleSubmit =()=>{
      setTimeToValidate(true);
      let contentBody="";
      
      /***
      setFormData({
        ...formData,
        ['project_code']: 'ABC123',
       });
      
      setFormData({
        ...formData,
        ['project_status']: 'Active',
       });
       ***/
       console.log("formData.project_code=" + formData.project_code);
       console.log("formData.project_status=" + formData.project_status);
       console.log("");
       
       const newErrors = validateForm(formData);
       setErrors(newErrors);
       
       if(Object.keys(newErrors).length === 0){
        console.log("");
       }
       else{
        return;
       }
      /***
      let contentBody={
            'project_category_id': ProjectCategoryId,
            'project_name': ProjectName,
            'country': Country,
            'city': City,
            'district': District,
            'ward': Ward,
            'project_code': 'ABC123',
            'project_status': 'Active',
             }
      ***/
     /***
      console.log("contentBody=" + contentBody['project_category_id'])
      console.log("contentBody=" + contentBody['name'])
      console.log("contentBody=" + contentBody['country'])
      console.log("contentBody=" + contentBody['city'])
      console.log("contentBody=" + contentBody['district'])
      console.log("contentBody=" + contentBody['ward'])
      console.log("contentBody=" + contentBody['project_code'])
      ***/
      let APIURL="/myapi/PostNewProjectView"
      let HeaderOptions={
        method: 'POST',
        headers: { 'Content-Type': 'Application/json' },
        body: JSON.stringify(formData)
      }

      fetch(APIURL, HeaderOptions)
      .then( response => response.json() )
      .then( json => setResponseStatus(json) )

      .finally(()=>{
       console.log("ResponseStatus=" + ResponseStatus);

      })
    }

    const customStyles = {
        option: (base, { data, isDisabled, isFocused, isSelected }) => {
        return {
          ...base,
          backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        };
      }
    };
    
    
    const loadServiceCategoryDataToSelect=(loadedData)=>{
     let ld=[]
     ld.push({id: 0, value: 'Select Project Category', label: 'Select Project Category', name: 'project_category_id'})
     
     loadedData.map(function(data){
      
        ld.push({
        id: data.id, value: data.name, label: data.name, name: 'project_category_id'
      });
      console.log("data.id, data.name=" + data.id + "," +  data.name);
     });
     
     setProjectCategory(ld);

    };

    const APIURLToGetServiceCategory="/myapi/ServiceCategoryListView";
    const headerOptionsToGetServiceCategory={
     method: 'GET',
     headers: {'Content-Type': 'Application/json'},
    };
    
    const [SCData, setSCData]=useState([{}]);
    
    useEffect(()=>{
    
     fetch(APIURLToGetServiceCategory)
    .then( response =>response.json())
    //.then( json=> setSCData(json))
    .then( json=> loadServiceCategoryDataToSelect(json))
    
    .finally(()=>{
     console.log("SCData=" + SCData);
     //loadServiceCategoryDataToSelect(SCData);
    })

    },[])
    
    const [ProjectCategoryId, setProjectCategoryId]=useState('');
    const handleProjectCategory=(e)=>{
      //e.preventDefault();
      console.log("e.value=" + e.value);
      console.log("e.label=" + e.label);
      console.log("e.id=" + e.id);
      
      //setProjectCategorySelected({id: e.id, value: e.value, label: e.value});
      setProjectCategoryId(e.id)
      console.log("ProjectCategoryId=" + ProjectCategoryId);
      setProjectCategorySelected({id: e.id, value: e.value, label: e.value});
      console.log("ProjectCategorySelected=" + ProjectCategorySelected);
      console.log("ProjectCategorySelected.value=" + ProjectCategorySelected['value']);

      //console.log("ProjectCategorySelected=" + ProjectCategorySelected);
      //console.log("ProjectCategorySelected_id=" + ProjectCategorySelected.id);
      //console.log("ProjectCategorySelected_value=" + ProjectCategorySelected.value);
      //console.log("ProjectCategorySelected_label=" + ProjectCategorySelected.label);
      //e.preventDefault();
    }

    const handleProjectName=(event)=>{
      console.log("event.target.value=" + event.target.value);
      setProjectName(event.target.value);
      console.log("ProjectName=" + ProjectName);
      event.preventDefault();
    }

    const handleCountry=(event)=>{
      console.log("event.target.value=" + event.target.value);
      setCountry(event.target.value);
      console.log("Country=" + Country);
      event.preventDefault();
    }

    const handleCity=(event)=>{
      console.log("event.target.value=" + event.target.value);
      setCity(event.target.value);
      console.log("City=" + City);
      event.preventDefault();
    }

    const handleDistrict=(event)=>{
      console.log("event.target.value=" + event.target.value);
      setCity(event.target.value);
      console.log("District=" + District);
      event.preventDefault();
    }

    const handleWard=(event)=>{
      console.log("event.target.value=" + event.target.value);
      setWard(event.target.value);
      console.log("Ward=" + Ward);
      event.preventDefault();
    }
     
     
    
    return(
    <Stack direction="row" spacing={1}>
     <StyledBox flex={4}>

    
     <TXTRoundedDiv>
        <Select
        name="project_category_id"
        options={ProjectCategory}
        onChange={(e)=>handleChangeSelect(e)}
        styles={customStyles}
        //value={formData.project_category_id}
        //value={ProjectCategorySelected} onHandleChange
        
        />
        {errors.project_category_id &&
        (<span className="error-message">
        {errors.project_category_id}
        </span>)
        }
     </TXTRoundedDiv>
     
     <TXTRoundedDiv>
            <StyledInput 
            placeholder="Project Name"
            onChange={(e)=>handleChangeInput(e)}
            //value={ProjectName}
            name="project_name"
            />
            {errors.project_name &&
            (
            <span className="error-message">
            {errors.project_name}
            </span>
            )
            }
      </TXTRoundedDiv>

        <TXTRoundedDiv>
            <StyledInput 
            placeholder="Country"
            name="country"
            onChange={(e)=>handleChangeInput(e)}
            //value={Country}
            />
            {errors.country &&
            (
            <span className="error-message">
            {errors.country}
            </span>
            )
            }
        </TXTRoundedDiv>

        <TXTRoundedDiv>
            <StyledInput 
            placeholder="City"
            name="city"
            onChange={(e)=>handleChangeInput(e)}
            //value={City}
            />
            {errors.city &&
            (
            <span className="error-message">
            {errors.city}
            </span>
            )
            }
        </TXTRoundedDiv>

        <TXTRoundedDiv>
            <StyledInput 
            placeholder="District"
            name="district"
            onChange={(e)=>handleChangeInput(e)}
            //value={District}
            />
            {errors.district &&
            (
            <span className="error-message">
            {errors.district}
            </span>
            )
            }
        </TXTRoundedDiv>

        <TXTRoundedDiv>
            <StyledInput 
            placeholder="Ward"
            name="ward"
            onChange={(e)=>handleChangeInput(e)}
            //value={Ward}
            />
            {errors.ward &&
            (
            <span className="error-message">
            {errors.ward}
            </span>
            )
            }
        </TXTRoundedDiv>

        <Button type="submit" color="secondary" variant="contained" onClick={handleSubmit}>
         SAVE
        </Button>

     </StyledBox>

     <StyledBox flex={4}>
     </StyledBox>

     <StyledBox flex={4}>
     </StyledBox>
    </Stack>
   )
}
